import { useEffect } from 'react';

const CalendlyButton = ({ url = "https://calendly.com/gdivision/rdv", text = "Prendre Rendez-vous", className = "" }) => {
  useEffect(() => {
    // Load Calendly script if not already loaded
    if (!document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  const openCalendly = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({ url });
    } else {
      // Fallback: open in new tab if Calendly script not loaded
      window.open(url, '_blank');
    }
  };

  return (
    <>
      <link href="https://assets.calendly.com/assets/external/widget.css" rel="stylesheet" />
      <button
        onClick={openCalendly}
        className={className}
        type="button"
      >
        {text}
      </button>
    </>
  );
};

export default CalendlyButton;
